<template>
  <div class="navtab">
    <div
      class="item"
      :class="item?.resourceGroup && disabledRbacTab(item) && 'disabled-navTab'"
      v-for="(item, index) in enabledNavtabs"
      :key="index"
    >
      <router-link
        :to="{ name: item.path }"
        class="router"
        active-class="activeRouter"
        :id="`nav-tab-${item.path}`"
      >
        <div class="routeLinkBox" v-if="!item.hide">
          {{ item.name }}
          <div v-if="item.isBeta" class="beta-icon">
            {{ $t('beta') }}
          </div>
        </div>
        <div :class="{ bottomdiv: item.path === currentRoute }"></div>
      </router-link>
    </div>
    <div v-if="showprofile" class="item">
      <router-link
        :to="{ name: 'profile' }"
        class="router"
        active-class="activeRouter"
        :id="`nav-tab-profile`"
      >
        <div class="">
          {{ $t('profile') }}
        </div>
        <div :class="{ bottomdiv: 'profile' === currentRoute }"></div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { LanguageNames } from '@/utils/enums/languageNames';
import { SubTypes } from '@/utils/enums/subTypes';
import { disableTabsForOcUser } from '@/components/Settings/userAdministration/userCreation.types';
import { navTabsMapper } from '@/components/Main/main.config';
import { usePermissions } from '@/hooks/usePermissions';
import BuildConfig from '@/environment';

const { hasCapabilityPermissionByRoute, hasCapabilityWritePermissionByRoute } =
  usePermissions();

export default {
  components: {},

  computed: {
    // a computed getter
    ...mapState('apmState/apmCommonState', [
      'currentInstance',
      'currentServiceLanguage',
      'subtype',
    ]),
    ...mapState('globalState', ['app', 'user', 'settings']),
    ...mapMutations('globalState/app', ['setTemplate']),
    showprofile() {
      if (
        this.app.currentSideNav.name === 'APM' &&
        this.currentServiceLanguage === LanguageNames.JAVA
      )
        return this.subtype !== SubTypes.OTEL;
      else return false;
    },
    currentRoute() {
      let full = this.$route.path;
      let splits = full.split('/');
      return splits[2];
    },
    enableOCIntegration() {
      return BuildConfig.VUE_APP_ENABLE_OC_INTEGRATION === 'true';
    },
    enabledNavtabs() {
      const navTabs = navTabsMapper[this.app.currentSideNav.key]?.() || [];

      return navTabs.filter((tabs) => {
        if (disableTabsForOcUser.includes(tabs.path)) {
          if (!this.enableOCIntegration) {
            return this.user?.isBillingAdmin;
          }

          return false;
        }

        return true;
      });
    },
  },
  methods: {
    ...mapActions('apmState/apmCommonState', ['getServiceLanguage']),
    disabledRbacTab(item) {
      return item?.isPlatformAdminAccess
        ? !hasCapabilityWritePermissionByRoute(item.resourceGroup)
        : !hasCapabilityPermissionByRoute(item.resourceGroup);
    },
  },
  mounted() {
    //set initial value for currentServiceLanguage
    if (this.currentServiceLanguage === '') {
      this.getServiceLanguage();
    }
  },
};
</script>

<style lang="scss" scoped>
.navtab {
  // margin-right: 0.9375em;
  display: flex;
  flex-direction: row;
  align-items: center;
  //   justify-content: space-;
  background-color: transparent;
  //color: $font-primary;
  height: 2.7188em;
  border-bottom: 0.25em solid $line-separator;
  border-radius: 0.125em;
  margin-top: 1em;
}
.item {
  //   margin: 5px;
  height: 100%;
  width: auto;
  border-radius: 0.125em;
  // border-bottom: 0.25em solid $font-primary;
  text-align: left;
  //color: $font-primary;
  text-decoration: none;
  display: flex;
  flex-direction: row;
  //   margin-right: auto;
}
.router {
  text-decoration: none;
  color: $font-primary;
  width: 14.313em;
  height: 2.5em;
  width: auto;
  // margin-bottom: -2.25em;
  border-radius: 2px;
  margin-right: 2.5em;
  // border-bottom: 0.2em solid $font-primary;
  text-align: left;
  line-height: 1.5625em;
  font-size: 1.25em;
}
.activeRouter {
  cursor: pointer;
  color: $color-brand-accent !important;
  font-family: $semi-bold;
}
.router:hover {
  color: $color-brand-accent;
}
.routeLinkBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 1500px) {
  .router {
    height: 1.9375em;
  }
}
.bottomdiv {
  background-color: $color-brand-accent;
  //  width: calc(100% + 10px);
  align-content: center;
  border-radius: 0.125em;
  height: 0.5em;
  //border: 1px solid $bg-primary;
  margin-top: 0.2em;
  @include dropshadow-effect;
  transition: opacity 3s ease-in-out;
  -webkit-transition: opacity 3s ease-in-out;
  -moz-transition: opacity 3s ease-in-out;
  -ms-transition: opacity 3s ease-in-out;
  -o-transition: opacity 3s ease-in-out;
}
.beta-icon {
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 0.25rem;
  background-color: $color-white;
  padding: 0.188rem 0.25rem;
  color: $color-black;
  height: 1.125rem;
  @include flex-center-justify(center);
  margin-left: 0.563rem;
}
.disabled-navTab {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
</style>
